'use client';

import React from 'react';

export default function KioskOfflineState() {
  return (
    <div className="flex flex-col items-center gap-8 max-w-lg w-full text-center">
      {/* Offline icon */}
      <div className="w-28 h-28 rounded-full offline-banner flex items-center justify-center">
        <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="text-kiosk-red">
          <line x1="1" y1="1" x2="23" y2="23"/>
          <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"/>
          <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"/>
          <path d="M10.71 5.05A16 16 0 0 1 22.56 9"/>
          <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"/>
          <path d="M8.53 16.11a6 6 0 0 1 6.95 0"/>
          <line x1="12" y1="20" x2="12.01" y2="20"/>
        </svg>
      </div>

      <div>
        <h2 className="text-3xl font-bold kiosk-text mb-3">
          Connection unavailable
        </h2>
        <p className="kiosk-muted text-xl leading-relaxed">
          Time clock temporarily unavailable.
        </p>
        <p className="kiosk-muted text-xl leading-relaxed mt-1">
          Please try again in a moment.
        </p>
      </div>

      <div className="offline-banner rounded-2xl px-8 py-5 w-full">
        <p className="text-kiosk-red font-semibold text-lg mb-2">
          ⚠ Official punches require server confirmation
        </p>
        <p className="kiosk-muted text-base">
          Do not attempt to record attendance manually during outages.
          All clock events are server-authoritative and require a live connection.
        </p>
      </div>

      <div className="flex items-center gap-3 kiosk-muted text-base">
        <div className="w-4 h-4 border-2 border-gray-600 border-t-gray-300 rounded-full animate-spin" />
        Attempting to reconnect...
      </div>
    </div>
  );
}